import { Column, Row } from 'app/design/primitives/box';
import { Checkbox } from 'app/design/primitives/checkbox';
import { Text } from 'app/design/primitives/text';
import type { Language } from 'app/lib/language';
import { createTheme as createDSTheme } from 'app/shopify';
import type { PopularItem } from 'app/types/category';
import { Controller, type Control, type ControllerRenderProps, type FieldValues } from 'react-hook-form';
import { Pressable } from 'react-native';

const theme = createDSTheme();

interface PopularItemSelectionListProps {
  control: Control;
  items: PopularItem[] | undefined;
  language: Language;
  onToggle: (item: PopularItem, field: ControllerRenderProps<FieldValues, `row_${string}`>) => void;
}

export function PopularItemSelectionList({ control, items, language, onToggle }: PopularItemSelectionListProps) {
  return (
    <Column>
      {items?.map((item, index) => (
        <Controller
          control={control}
          key={item.id}
          name={`row_${index.toString()}`}
          render={({ field }) => (
            <Pressable onPress={() => onToggle(item, field)}>
              <Row
                alignItems="center"
                height={48}
                marginVertical="spacing.general.x1"
                style={{
                  backgroundColor: theme.colors['surface.default'],
                  borderRadius: theme.borderRadii['radius.lg'],
                  paddingHorizontal: 20,
                  paddingVertical: theme.spacing['spacing.general.x1'],
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Text flex={2} flexShrink={1} numberOfLines={1}>
                  {item[language]}
                </Text>
                <Checkbox checked={item.selected} onPress={() => onToggle(item, field)} />
              </Row>
            </Pressable>
          )}
        />
      ))}
    </Column>
  );
}
